import React, { useEffect, useState } from "react";
import { Input, message, Modal, notification, Select } from "antd";
import WebUtils from "../../../../../utils/WebUtils";
import submitSvg from "../../../../../assets/Illustrations/submit.svg";
import tick from "../../../../../assets/Illustrations/successTick.svg";
import { finalizeResumeFileApi } from "../../../../../api/b2b-candidate";
import { useNavigate } from "react-router-dom";

function SaveAnotherCopyModal({
  saveCopyModal,
  setSaveCopyModal,
  setLoading,
  resumeMetaData,
  buildSavePayload,
  userDetail,
  generatePdfBlob,
}) {
  const navigate = useNavigate();
  const [resumeName, setResumeName] = useState(
    "Copy_of_" + resumeMetaData?.resumeFileName,
  );
  const [isSuccess, setIsSuccess] = useState(false);

  const saveAsAnotherCopy = async () => {
    try {
      setLoading(true);

      const pdfBlob = await generatePdfBlob();
      const resumeFile = new File([pdfBlob], `${resumeName}.pdf`, {
        type: "application/pdf",
      });

      const { resumeData, sectionOrder } = buildSavePayload?.() ?? {};

      const formData = new FormData();
      formData.append("resumeFile", resumeFile);
      formData.append(
        "candidateResumeUploadRequest",
        JSON.stringify({
          userIdentifier: userDetail?.userIdentifier,
          organizationId: userDetail?.organizationId,
          resumeData,
          sectionOrder,
          resumeFileName: resumeName,
          resumeIdentifier: null,
        }),
      );

      const result = await WebUtils.httpOperations(
        finalizeResumeFileApi,
        formData,
        "POST",
      );

      if (
        result?.data?.resultStatusInfo?.resultCode?.toLowerCase() === "success"
      ) {
        setIsSuccess(true);
      } else {
        notification.error({
          message: "Failed",
          description: result?.data?.resultStatusInfo?.message,
          placement: "topRight",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!resumeName?.trim()) {
      message.error("Please provide a resume name!");
      return;
    }
    saveAsAnotherCopy();
  };

  const handleClose = () => {
    setIsSuccess(false);
    setSaveCopyModal(false);
  };

  return (
    <Modal
      open={saveCopyModal}
      onCancel={handleClose}
      footer={null}
      centered
      width={520}
    >
      {!isSuccess ? (
        <>
          <div className="flex flex-col justify-center gap-[.6rem] items-center">
            <div>
              <img src={submitSvg} width={230} alt="" />
            </div>

            <p className="text-lg font-semibold text-[#0F1B23]">
              Save As Another Copy
            </p>

            <p className="text-sm text-center text-[#475467] max-w-[400px]">
              Create a copy of the latest version of your current resume.
            </p>

            <div className="flex gap-[.5rem] items-center mt-3 w-[400px]">
              <div className="w-[80px] text-[#475467] text-sm">File Name:</div>

              <div className="flex-1">
                <Input
                  value={resumeName}
                  onChange={(e) => {
                    const sanitized = e.target.value.replace(
                      /[^a-zA-Z0-9_()]/g,
                      "",
                    );
                    setResumeName(sanitized);
                  }}
                  placeholder="Enter file name"
                  className="rounded-[6px] py-1 w-full"
                />
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3 mt-6">
            <button
              className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
              onClick={handleClose}
            >
              Cancel
            </button>

            <button
              onClick={handleSubmit}
              className="btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full"
            >
              Create Copy
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col justify-center items-center gap-3">
            <div className="">
              <img alt="" width={200} src={tick} />
            </div>

            <p className="text-lg font-semibold text-[#0F1B23]">
              Resume Copied Successfully!
            </p>

            <p className="text-sm text-center text-[#475467] max-w-[400px]">
              A copy of your resume has been created successfully.
            </p>
          </div>

          <div className="flex items-center gap-3 mt-6">
            <button
              className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
              onClick={handleClose}
            >
              Cancel
            </button>

            <button
              className="btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full"
              onClick={() => navigate("/cv-optimizer?tab=allResumes")} // your route here
            >
              View All Resumes
            </button>
          </div>
        </>
      )}
    </Modal>
  );
}

export default SaveAnotherCopyModal;
